import { Button } from '../button/Button';
import { withPersonalizedButtonStyle } from '../button/withPersonalizedButtonStyle';
import { styles } from './PrimaryButton.styles';

export const PrimaryButton = withPersonalizedButtonStyle(Button, styles);
